import PageHeader from "../../../common/components/PageHeader";
import { useTranslator } from "../../../common/state/translatorState";
import ContactReportList from "../components/ContactReportList";
import ContactReportListFilter from "../components/ContactReportListFilter";
import { ContactReportQueryType } from "../contactReportSchemas";
import { useContactReportQueryMetadata } from "../contactReportState";

const type: ContactReportQueryType = "on-behalf-of";

const OnBehalfOfContactReportsListScreen = () => {
  const t = useTranslator();
  const metadata = useContactReportQueryMetadata(type);

  return (
    <>
      <PageHeader className="mb-2">{t.ContactReportsList.Header.OnBehalfOf.Title}</PageHeader>
      <ContactReportListFilter type={metadata.type} className="mb-4" />
      <ContactReportList metadata={metadata} />
    </>
  );
};

export default OnBehalfOfContactReportsListScreen;
